<template>
  <v-autocomplete
    v-model="selectedOwner"
    :items="owners"
    :loading="isLoading"
    :search-input.sync="searchKey"
    :label="label"
    :placeholder="placeholder"
    :disabled="disabled"
    :clearable="clearable"
    item-text="companyName"
    item-value="id"
    return-object
    hide-no-data
    no-filter
  >
    <template slot="item" slot-scope="{ item }">
      <div style="width: 100%">
        <div>{{ item.companyName }}</div>
        <div><small>{{ item.contactName || item.contactEmail || item.contactPhone || '' }}</small></div>
        <hr style="width: 100%; border: 0; border-bottom: 1px solid #ccc" />
      </div>
    </template>
    <template slot="selection" slot-scope="{ item }">
      <div>{{ item.companyName }}</div>
    </template>
  </v-autocomplete>
</template>

<script>
import src from './src'

export default src
</script>
